import {
	Component,
	OnDestroy,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
} from "@angular/core";

import { OnInit } from "@angular/core";
import { EventBusService } from "../../services/event-bus.service";
import { IncidentService } from "../../services/incident.services";
import * as io from "socket.io-client";
import { environment } from "../../environments/environment";
import { GlobalCfgService } from "src/services/globalcfg.service";
import { GeoFenceService } from "src/services/geofence.service";
import { MiscService } from "src/services/misc.service";
declare var google: any;
@Component({
	selector: "rm-incidents-map",
	templateUrl: "./map.component.html",
	styleUrls: ["./map.component.css"],
})
export class MapComponent implements OnInit, OnDestroy, OnChanges {
	@Input()
	productId: string;

	_gcp: string;
	heatmap: any;
	get gcp() {
		return this._gcp;
	}

	@Input()
	set gcp(val) {
		this._gcp = val;
		this.loadHeatmap();
	}

	@Input()
	batchNum: string;

	@Input()
	gln: string;

	@Input()
	incidentType: string;

	@Input()
	incidentShowFences: any[] = [];

	@Input()
	showFences: boolean = false;

	allBatchFences: any[] = [];
	subscriptions: any = [];
	batchOverlays: any[] = [];

	constructor(
		private ebService: EventBusService,
		private incidentService: IncidentService,
		private globalCfgService: GlobalCfgService,
		private geofenceservice: GeoFenceService,
		private miscService: MiscService
	) {}

	google: any;
	gmap: any;

	neighborhoods = [{ lat: 17.4327185, lng: 78.5079356 }];
	markers = [];

	ngOnInit() {
		this.google = window["google"];
		this.gmap = new this.google.maps.Map(
			document.getElementById("rm_map_div"),
			{
				center: { lat: 51.476852, lng: -0.0005 },
				zoom: 2,
				maxZoom: 11,
				mapId: "32c64ca2d80e5193",
			}
		);

		this.subscriptions.push(
			this.ebService.realtimeEventValue$.subscribe((event) => {
				console.log("Received event data....");
			})
		);

		this.loadHeatmap();
		this.eventListner(this);
	}

	ngOnChanges(changes: SimpleChanges) {
		this.loadHeatmap();
		// console.log("changes", changes);
		// handle hide fences action
		if (changes.showFences && changes.showFences.previousValue) {
			if (
				changes.showFences.currentValue === false &&
				changes.showFences.previousValue === true
			) {
				// map overlay refs that are removed for non regional fence types
				this.batchOverlays.forEach((o) => {
					o.setMap(null);
				});
				// check if regional fence exist and remove that from map view
				this.gmap.data.forEach(feature => {
					this.gmap.data.remove(feature);
				});
			}
		}
		// handle show fences action
		if (
			changes.incidentShowFences &&
			changes.incidentShowFences.currentValue.length > 0
		) {
			this.allBatchFences = changes.incidentShowFences.currentValue;
			this.showGeoFenceDataOnMapReadOnly(this.allBatchFences, this.gmap);
		}
	}

	showGeoFenceDataOnMapReadOnly(fences, mapRef) {
		// console.log(fences);
		fences.forEach((fenceObj) => {
			if (fenceObj.type === "region") {
				let regionValue = fenceObj.value.replace("[", "");
				regionValue = regionValue.replace("]", "");
				this.fetchAndShowRegionFence(regionValue, fenceObj.inside, mapRef);
			} else if (fenceObj.type === "rectangle") {
				this.showRectangleFence(fenceObj.value, fenceObj.inside, mapRef);
			} else if (fenceObj.type === "circle") {
				this.showCircleFence(fenceObj.value, fenceObj.inside, mapRef);
			} else if (fenceObj.type === "polyline") {
				this.showPolyLineFence(fenceObj.value, fenceObj.inside,mapRef);
			} else if (fenceObj.type === "polygon") {
				this.showPolygonFence(fenceObj.value, fenceObj.inside, mapRef);
			}
		});
	}

	fetchAndShowRegionFence(regionValue, inside, mapRef) {
		regionValue = regionValue.toLowerCase();
		this.miscService.geocodeQuery(regionValue).subscribe((result: any) => {
			if (result.length > 0) {

				var latlonArr = this.geofenceservice.getLatLngArr(result[0]);
				let regionCoords = [];
				latlonArr.forEach((item) => {
					regionCoords = [...regionCoords, item];
					// const geometryObj = new this.google.maps.Data.Polygon([item]);

					// mapRef.data.add({
					// 	geometry: geometryObj,
					// });
				});
				const regionalFenceOverlay = new this.google.maps.Polygon({
					paths: regionCoords,
					fillColor: inside ? "#40ec40" : "#ff0000",
					strokeColor: inside ? "green" : "red",
					strokeWeight: 1
				});
				regionalFenceOverlay.setMap(mapRef);
			}
		});
	}

	showRectangleFence(data, inside, mapRef) {
		const rect = this.geofenceservice.showRectangleFence(data, inside, mapRef);
		const rectangle = new this.google.maps.Rectangle(rect);
		this.batchOverlays.push(rectangle);
	}

	showCircleFence(data, inside, mapRef) {
		const circlefence = this.geofenceservice.showCircleFence(data, inside, mapRef);
		const circle = new this.google.maps.Circle(circlefence);
		this.batchOverlays.push(circle);
	}

	showPolyLineFence(data, inside, mapRef) {
		const polylinefence = this.geofenceservice.showPolygonFence(data, inside, mapRef);
		const polyLineOverlay = new this.google.maps.Polygon(polylinefence);
		polyLineOverlay.setMap(mapRef);
		this.batchOverlays.push(polyLineOverlay);
	}

	showPolygonFence(data, inside, mapRef) {
		const polygonfence = this.geofenceservice.showPolygonFence(data, inside, mapRef);
		const polygonOverlay = new this.google.maps.Polygon(polygonfence);
		polygonOverlay.setMap(mapRef);
		this.batchOverlays.push(polygonOverlay);
	}

	eventListner(thisRef) {
		var socket = io(
			environment.socketUrl + "?apiKey=" + environment.websocketApiKey,
			{ transport: ["websocket"] }
		);

		socket.on("connect", function () {
			console.log("Connection to socket io established...");
		});
		socket.on("validate", function (event) {
			var eventData = event.txnEvent;
			console.log("eventData", eventData);
			var position = eventData.readPoint;

			let positionVal: any = {
				lat: parseFloat(position.lat),
				lng: parseFloat(position.lng),
			};
			if (eventData.validationLevel === "error") {
				thisRef.addMarkerWithTimeout(thisRef, positionVal, "RED", eventData);
			} else if (eventData.validationLevel === "warn") {
				thisRef.addMarkerWithTimeout(
					thisRef,
					positionVal,
					"#FFD700",
					eventData
				);
			} else if (eventData.validationLevel === "info") {
				thisRef.addMarkerWithTimeout(
					thisRef,
					positionVal,
					"#2FC8C8",
					eventData
				);
			} else {
				thisRef.addMarkerWithTimeout(thisRef, positionVal, "ORANGE", eventData);
			}
		});
	}

	addMarkerWithTimeout(thisref, position, color, eventData) {
		let currentTemperature = "";
		let currentMoisture = "";

		if (eventData.isTemperatureSensitive) {
			currentTemperature =
				"<p>Temperature : <b> " + eventData.temperature + "</b> </p>";
		}

		if (eventData.isHumiditySensitive) {
			currentMoisture = "<p>Humidity : <b> " + eventData.humidity + "</b> </p>";
		}

		var contentString =
			'<div id="content">' +
			"<p>Medicine Name : <b> " +
			eventData.name +
			"</b> </p>" +
			"<p>Medicine Status : <b> " +
			eventData.instanceStatus +
			"</b> </p>" +
			"<p>Action : <b> " +
			eventData.txnType +
			"</b> </p>" +
			"<p>User Name : <b> " +
			eventData.user.name +
			"</b> </p>" +
			currentTemperature +
			currentMoisture +
			"</div>";

		var infowindow = new google.maps.InfoWindow({
			content: contentString,
		});

		var marker = new google.maps.Marker({
			position: position,
			map: thisref.gmap,
			animation: google.maps.Animation.DROP,
			icon: {
				path:
					"M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0",
				fillColor: color,
				fillOpacity: 1,
				strokeColor: "#000",
				strokeWeight: 0.5,
				scale: 1.2,
			},
		});

		marker.addListener("click", function () {
			infowindow.open(thisref.gmap, marker);
		});
	}

	loadHeatmap() {
		if (
			!this.gcp &&
			this.globalCfgService.getFullUserObj()["role"] != "admin"
		) {
			this.gcp = this.globalCfgService.getGcp();
		}

		var rec = {};

		if (this.gcp) {
			rec["gcp"] = this.gcp;
		}

		if (this.productId != "all") {
			rec["gtin"] = this.productId;
		}
		if (this.batchNum) {
			rec["batch"] = this.batchNum;
		}
		if (this.gln) {
			rec["gln"] = this.gln;
		}

		rec["eventType"] =
			this.incidentType && this.incidentType.length > 0
				? this.incidentType
				: null;

		this.incidentService.getHeatmapData(rec).subscribe((response: any) => {
			var data = response.data;
			var mapData = [];
			var ln = data.length;
			for (var i = 0; i < ln; i++) {
				var t = data[i];
				var loc = t.location;
				if (loc) {
					mapData.push({
						location: new this.google.maps.LatLng({
							lat: parseFloat(loc.lat),
							lng: parseFloat(loc.lng),
						}),
						weight: parseFloat(t.weight),
					});
				}
			}

			if (this.heatmap) {
				this.heatmap.setMap(null);
				this.heatmap = null;
			}

			this.heatmap = new this.google.maps.visualization.HeatmapLayer({
				data: mapData,
				map: this.gmap,
				radius: 24,
			});

			// this.google.maps.event.addListener(this.gmap, 'bounds_changed', function() {
			//   var bounds = this.gmap.getBounds();
			//   // var bounds = new this.google.maps.LatLngBounds();

			//   console.log("get bounds: ", bounds);

			//   debugger
			//   var NECorner = bounds.getNorthEast();
			//   var SWCorner = bounds.getSouthWest();

			//   var NWCorner = new this.google.maps.LatLng(NECorner.lat(), SWCorner.lng());
			//   var SECorner = new this.google.maps.LatLng(SWCorner.lat(), NECorner.lng());
			//   // var NWCorner = bounds.getNorthWest();
			//   // var SECorner = bounds.getSouthEast();
			//   console.log(" North East corner: ", NECorner);
			//   console.log(" South West corner: ", SWCorner);
			//   console.log(" North West corner: ", NWCorner);
			//   console.log(" South East corner: ", SECorner);

			//   var polygon = new this.google.maps.Polygon({
			//     map: this.gmap,
			//     paths: [NWCorner, NECorner, SECorner, SWCorner],
			//     fillColor: 'red',
			//     fillOpacity: 0.7
			//   });
			// });
		});
	}

	ngOnDestroy() {
		this.subscriptions.forEach((s) => s.unsubscribe());
	}
}
